import { HttpClient } from "@angular/common/http";
import {Component,ElementRef,OnInit, ViewChild} from "@angular/core";
import { Router } from "@angular/router";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { DataTableDirective } from "angular-datatables";
import * as moment from "moment";
import { Subject } from "rxjs";
import { EncryptionService } from "src/app/_services/encryption.service";
import { ExcelService } from "src/app/_services/excel.service";
import { MentorshipDashboardService } from "src/app/_services/mentorship-dashboard.service";

declare const $: any;
  
class DataTablesResponse {
    data: any[];
    draw: number;
    recordsFiltered: number;
    recordsTotal: number;
}

@Component({
    selector: 'app-request-sent-by-mentee',
    templateUrl: './request-sent-by-mentee.component.html'
})


export class ReqSentByMenteeComponent implements OnInit{
  @ViewChild("datePicker", { static: false }) datePicker: ElementRef;

  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  // dtOptions: DataTables.Settings = {};
  dtOptions: DataTables.Settings = {
    pagingType: "full_numbers",
    pageLength: 10,
    columnDefs: [{ targets: [6], orderable: false }],
  };
  
  exportMenteeReqList: any = [];
  fieldsToIncludeExcel: any = [];
  exl: boolean = false;

  totalReqSent: any;
  modalReference: NgbActiveModal;
  modalCropper: NgbActiveModal;
  isSubmitted = false;
  dateInvalid: boolean = false;
  showloding = true;
  lodingImage = false;
  dtTrigger = new Subject();
  reqSendByMenteeArr: any = []; // Table Data list
  startDate: any = '';
  endDate: any = '';
  start_date:any
  end_date:any
  today: string = '';


  constructor(
    public router: Router,
    private http: HttpClient,
    private enc_dec: EncryptionService,
    private dataService: MentorshipDashboardService,
    private excelService: ExcelService,
  ) {
    const now = new Date();
    this.today = now.toISOString().split('T')[0];
  }


  ngOnInit() {
    window.scroll(0, 0);
    const strtDate = sessionStorage.getItem('startDate');
    const endDate = sessionStorage.getItem('endDate');
    this.startDate = strtDate ;
    this.endDate = endDate ;

    this.getListing() 
    this.reqSendListing()
    }


  getListing() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      serverSide: true,
      processing: true,
      ajax: (dataTablesParameters: any, callback) => {
        const data = {
          "type" : 'requests_sent_by_mentees',
          "export": false,
          "start_date": this.startDate,
          "end_date": this.endDate,
      }

        const requestPayload = {
          ...dataTablesParameters,
          ...data, 
        };
  
        const encryptedData = this.enc_dec.encrypt(JSON.stringify(requestPayload));
  
        this.http
          .post<DataTablesResponse>(
            '/api/metric-list',
            { req_data: encryptedData },
            {}
          )
          .subscribe((response: any) => {
            const output = this.enc_dec.decrypt(response.res_data);
            const resp = JSON.parse(output);
  
            this.reqSendByMenteeArr = resp['data'];
            this.totalReqSent = resp['recordsFiltered'];
  
            callback({
              recordsTotal: resp['recordsTotal'],
              recordsFiltered: resp['recordsFiltered'],
              data: [], 
            });
          });
        },
      columns: [
        { data: 'id' },
        { data: 'user_name' },
        { data: 'connected_to_name' },
        { data: 'connection_status' },
        { data: 'created_at' },
        // { data: 'connect_type' },

      ],
    }
   }


  reqSendListing() {
  
    const data =  {
      "draw": 1,
      "start": 0,
      "length": 1,
      "order": [
          {
              "column": 0,
              "dir": "asc"
          }
      ],
      "search": {
          "value": "",
          "regex": false
      },
       "start_date":this.startDate,
       "end_date": this.endDate,
       "export": true,
       "type": "requests_sent_by_mentees"
     }


    this.loadShow();
    this.dataService
      .dataExport(data)
      .pipe()
      .subscribe((res) => {
          this.exportMenteeReqList = res["data"];
          this.fieldsToIncludeExcel = [
            "user_name",
            "connected_to_name",
            "connection_status",
            "created_at"
          ];
          this.exl = true;
     
        this.loadHide();
      });
  }

  
  onSearch() {
    this.isSubmitted = true;
    this.dateInvalid = false;
  
    if (!this.startDate || !this.endDate) {
      return;
    }
  
    const start = new Date(this.startDate);
    const end = new Date(this.endDate);
  
    if (start > end) {
      this.dateInvalid = true;
      return;
    }
    const table = $("#req_mentors").DataTable();
    table.ajax.reload(null, false);
    this.reqSendListing()
  } 


  // onReset() {
      // if (this.datePicker.nativeElement.value) {
      //   this.onClear();
      //   this.datePicker.nativeElement.value = "";
      // } else {
      //   this.datePicker.nativeElement.value = "";
      // }
  // }
  
    onFilter(startDateInput?: string, endDateInput?: string) {
      const datePicker = $(this.datePicker.nativeElement);
      datePicker.attr("placeholder", "Select Date Range");
    
      let start: moment.Moment | null = null;
      let end: moment.Moment | null = null;
    
      if (startDateInput && endDateInput) {
        start = moment(startDateInput, "MM/DD/YYYY");
        end = moment(endDateInput, "MM/DD/YYYY");
    
        this.startDate = start.format("YYYY-MM-DD");
        this.endDate = end.format("YYYY-MM-DD");
      }
    
      datePicker.daterangepicker(
        {
          autoUpdateInput: !!start,
          showDropdowns: true,
          startDate: start || undefined,
          endDate: end || undefined,
          maxDate: moment(),
          locale: {
            format: "MM/DD/YYYY",
          },
        },
        (selectedStart, selectedEnd, label) => {
          this.startDate = selectedStart.format("YYYY-MM-DD");
          this.endDate = selectedEnd.format("YYYY-MM-DD");
    
          datePicker.val(
            selectedStart.format("MM/DD/YYYY") + " - " + selectedEnd.format("MM/DD/YYYY")
          );

          this.reqSendListing();
          const table = $("#req_mentors").DataTable();
          table.ajax.reload(null, false);
          this.loadShow();
        }
      );
    
      if (start && end) {
        datePicker.val(start.format("MM/DD/YYYY") + " - " + end.format("MM/DD/YYYY"));
      } else {
        datePicker.val('');
      }
    }

  onReset() {
      this.isSubmitted = false;
      this.startDate = ''
      this.endDate = ''
      const table = $("#req_mentors").DataTable();
      table.ajax.reload(null, false);
      this.reqSendListing()
  }
  
  exportToExcel() {
    this.excelService.generateExcel(
      this.exportMenteeReqList,
      this.fieldsToIncludeExcel,
      "Req Sent By Mentee"
    );
  }

  loadShow() {
    this.showloding = true;
    this.lodingImage = false;
  }

  loadHide() {
    this.showloding = false;
    this.lodingImage = true;
  }


  ngAfterViewInit(): void {
    this.dtTrigger.next();
    $('#req_mentors').on('page.dt', function () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth' // optional for smooth scroll
      });
    });
  }

   ngOnDestroy(): void {
     $('#req_mentors').off('page.dt');
    this.dtTrigger.unsubscribe();
  }

  
      blockTyping(event: KeyboardEvent) {
        event.preventDefault(); 
      }


  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }
}
